import React from 'react';
import cn from 'classnames';

import SearchHits from './Subcomponents/SearchHits';
import {IProductsGridProps} from './IProductsGrid';

import styles from './ProductsGrid.module.scss';

const ProductsGrid = ({children, gridSize, classNames}: IProductsGridProps) => {
	return (
		<div
			className={cn(
				styles['products-grid'],
				'products-grid',
				{[styles[`products-grid--size-${gridSize}`]]: !!gridSize},
				classNames,
			)}
		>
			{children}
		</div>
	);
};

ProductsGrid.SearchHits = SearchHits;

export default ProductsGrid;
